export default __webpack_public_path__ + "static/media/ISKO CLASS-1 EXAM PATTERN 2026-27.1ec91a35.pdf";